import {TouchableOpacity, ScrollView} from 'react-native-web'
import { ReplyText } from '../../../element/Text'



export const Reply= props=>{
    return(
      <TouchableOpacity onPress={props.onPress} style={{width:'90%', height:'30%', backgroundColor:'#252525', borderRadius:15, shadowColor:'#000000', shadowOpacity:0.5, shadowRadius:5, shadowOffset:{width:5, height:5}, padding:15, borderColor:'#F9BA49', borderWidth:1.8}}>
          <ScrollView>
          <ReplyText title={props.value} body={props.value1}/>
          </ScrollView>
        </TouchableOpacity>);}